import { render, staticRenderFns } from "./PortableText.vue?vue&type=template&id=49a56e89&scoped=true"
import script from "./PortableText.vue?vue&type=script&lang=js"
export * from "./PortableText.vue?vue&type=script&lang=js"
import style0 from "./PortableText.vue?vue&type=style&index=0&id=49a56e89&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a56e89",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49a56e89')) {
      api.createRecord('49a56e89', component.options)
    } else {
      api.reload('49a56e89', component.options)
    }
    module.hot.accept("./PortableText.vue?vue&type=template&id=49a56e89&scoped=true", function () {
      api.rerender('49a56e89', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sanity/PortableText.vue"
export default component.exports